var Util = require('../../../FV/util'),
    SearchIndexModel = require('./SearchIndexModel');


/**
 * Now this is really tailored to the default searcher , may need more fine grained control
 * Maybe it's actually an index wrapper?
 * Before big changes, wait for feedback on how we want to search.
 * -- REALLY INDEX CREATOR -- CALL AS SUCH ---  ?
 *
 */

var TextSearcher = function( options ) {

    this.searchOptions = options.searchOptions;
    this.nSearchTerms = options.nSearchTerms;
    this.wordModels = options.wordModels; // word models to search to create the index

    this.index = this.createIndex(); // what you get when you do the search -- for now contains literals

    return this;

};


// Create the index -- maybe be different for different options ... at least somewhat breaking up now ...
// For efficiency, something like binary search? http://www.position-absolute.com/articles/optimizing-a-search-functionality-with-large-javascript-arrays/
// Return array of 'index objects' - that contains the text to search; when returned,
// will then be used to create the hits collection

TextSearcher.prototype.createIndex = function() {

    var nSearchTerms = this.nSearchTerms,
        allWordModelsInDocument = this.wordModels,
        nAllWordModelsInDocument = allWordModelsInDocument.length,
        ignoreCertainCharacters = this.searchOptions.get('ignoreCertainCharacters'),
        ignoreCharactersRegExp = this.searchOptions.getCharactersToIgnoreReg();

    // Wanted: arrays of word models who text (split with ' ') match the regex:
    // The # should be the same as the number of words ( now 'derived words' -- which includes dashes )
    // Maybe use library on the index if get more complicated requirements

    var index = [];

    for ( var wordIndex = 0; wordIndex < nAllWordModelsInDocument; wordIndex++ ) {

        // ( if slice's end is > greater than array length; it uses array length )
        var aAdjacentWordModels = allWordModelsInDocument.slice( wordIndex, wordIndex + nSearchTerms );
        var adjacentWordText = '';

        for (var m = 0; m < aAdjacentWordModels.length; m++ ) {

            adjacentWordText += aAdjacentWordModels[m].get('wd');

            // Note: we are no longer including spaces -- they aren't necessary
            /*
            if ( m < nWordModels -1 ) {
                adjacentWordText += ' '; // we assume a space in between; perhaps we look as logic for dashed
            }
            */
        }

        /**
         * Need to sanitize the the text to search for it ignore characters, in additional to sanitizing the search term.
         * Replacing on the way in seems performant.
         * The alternative 'non-elegant regexp' to look for term and exclude characters is more complex.
         * Side effect: if searching for these characters, hits will not be returned ( perhaps a fix is a different phase and
         * involving more search options ).
         */
        var wordTextToSearch = !ignoreCertainCharacters
            ? adjacentWordText
            : adjacentWordText.replace( ignoreCharactersRegExp, '' );

        index.push( new SearchIndexModel({
            words: aAdjacentWordModels,
            text: adjacentWordText, // keep in case?
            textToSearch: wordTextToSearch,
            numberWords: nSearchTerms
        }) );

    }



    return index;

};


/**
 *  This is basically the search
 *  The searchTerm is currently intertwined in creation of the index.
 *  Now filtering characters on the way (above): alternative would be something like
 *  var filter = '[.\-]*'; // testing ...
 *  (  https://stackoverflow.com/questions/55907086/regex-for-ignoring-special-characters-in-substring-search _
 *  Could put a fn on search options.
 *  Note: textToSearch now already has 'ignore characters' removed
*/
TextSearcher.prototype.getIndexHits = function( textToSearch ) {

    var userTextToSearch = textToSearch;

    // Get rid of spaces; ( need reg exp to replace all ) -- could use \s but thats all white space
    userTextToSearch = userTextToSearch.replace(/ /g, '');

    var regexModifier = 'g'; // may want whole words in a different iteration, options

    if ( this.searchOptions.get('ignoreCase') ) {
        regexModifier += 'i';
    }

    /* Since using the RegExp constructor with a string literal, we need to RegExp escape it. */
    var searchRegEx = new RegExp( Util.escapeRegExp( userTextToSearch ) , regexModifier );

    // Search Index W/The RegEx -- if perf an issue could apply could do the test in the initial loop
    // Consider index model a 'document' if move to 3rd party search library
    var indexHits = this.index.filter( function( indexModel ) {
        return searchRegEx.test( indexModel.textToSearch );
    });


    return indexHits;

};




module.exports = TextSearcher;


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/models/searchResults/TextSearcher.js
 ** module id = 658
 ** module chunks = 0
 **/